const baseUrl = process.env.REACT_APP_BASE_URL;

const urlConfig = {
  user: {
    login: `${baseUrl}/User/Login`,
    logout: `${baseUrl}/User/Logout`,
    passwordRecovery: `${baseUrl}/User/passwordRecovery`,
    passwordRecoveryToSubUser: `${baseUrl}/User/passwordRecoveryToSubUser`,
    passwordReset: `${baseUrl}/User/ResetPassword`,
    signup: `${baseUrl}/User/Signup`,
    authenticated: `${baseUrl}/User/Authenticated`,
    addUserAddress: `${baseUrl}/User/AddUserAddress`,
    getUserAddresses: `${baseUrl}/User/GetUserAddresses`,
    getUserAddress: `${baseUrl}/User/GetUserAddress`,
    uploadPicture: `${baseUrl}/User/UploadPicture`,
    getProfile: `${baseUrl}/User/getProfile`,
    getSellerProfile: `${baseUrl}/User/getSellerProfile`,
    updateSellerProfile: `${baseUrl}/User/updateSellerProfile`,
    updateUserAddress: `${baseUrl}/User/updateUserAddress`,
    getSellerProfileById: `${baseUrl}/User/getSellerProfileById`,
    addReferenceRequest: `${baseUrl}/User/addReferenceRequest`,
    getMyReferenceRequests: `${baseUrl}/User/getMyReferenceRequests`,
    getUserDrawerData: `${baseUrl}/User/getUserDrawerData`,
    approveReferenceResponse: `${baseUrl}/User/approveReferenceResponse`,
    rejectReferenceResponse: `${baseUrl}/User/rejectReferenceResponse`,
    getUserContactPermission: `${baseUrl}/User/getUserContactPermission`,
    updateUserContactPermission: `${baseUrl}/User/updateUserContactPermission`,
    checkUserIsMaster: `${baseUrl}/User/CheckUserIsMaster`,
    addSubUser: `${baseUrl}/User/AddSubUser`,
    getMySubAccounts: `${baseUrl}/User/GetMySubAccounts`,
    changeSubAccountStatus: `${baseUrl}/User/ChangeSubAccountStatus`,
    editSubUser: `${baseUrl}/User/EditSubUser`,
    activateAccount: `${baseUrl}/User/ActivateAccount`,
    getSubUserLog: `${baseUrl}/User/GetSubUserLog`,
    getMyRefAccounts: `${baseUrl}/User/GetMyRefAccounts`,
    addVKNFile: `${baseUrl}/User/AddVKNFile`,
    getMyFavSeller: `${baseUrl}/User/GetMyFavSeller`,
    addFavSeller: `${baseUrl}/User/AddFavSeller`,
    removeFavSeller: `${baseUrl}/User/RemoveFavSeller`,
    getMyBlockedSeller: `${baseUrl}/User/GetMyBlockedSeller`,
    addBlockedSeller: `${baseUrl}/User/AddBlockedSeller`,
    removeBlockedSeller: `${baseUrl}/User/RemoveBlockedSeller`,
    removeReferenceResponse: `${baseUrl}/User/RemoveReferenceResponse`,
    searchCompany: `${baseUrl}/User/SearchCompany`,
    SearchCompanyPaging: `${baseUrl}/User/SearchCompanyPaging`,
    getUserDepositList: `${baseUrl}/User/GetUserDepositList`,
    getDeposits: `${baseUrl}/User/GetDeposits`,
    getBalance: `${baseUrl}/User/GetBalance`,
    updateProfile: `${baseUrl}/User/UpdateProfile`,
    getDashboard: `${baseUrl}/User/GetDashboard`,
    markAnnouncementAsRead: `${baseUrl}/User/MarkAnnouncementAsRead`,
    changePassword: `${baseUrl}/User/changePassword`,
    getFavSellerGroup: `${baseUrl}/User/GetFavSellerGroup`,
    addFavSellerGroup: `${baseUrl}/User/AddFavSellerGroup`,
    removeFavSellerGroup: `${baseUrl}/User/RemoveFavSellerGroup`,
    updateFavSellerGroup: `${baseUrl}/User/UpdateFavSellerGroup`,
    getMyComments: `${baseUrl}/User/GetMyComments`,
    updateMyComment: `${baseUrl}/User/UpdateMyComment`,
    updateMyRefComment: `${baseUrl}/User/UpdateMyRefComment`,
  },
  common: {
    getCities: `${baseUrl}/Common/GetCityList`,
    getDistrictByCityId: `${baseUrl}/Common/GetDistrictList`,
    getStreetByDistrictId: `${baseUrl}/Common/GetStreetList`,
    getProduct: `${baseUrl}/Common/GetProduct`,
    getProductGroup: `${baseUrl}/Common/GetProductGroup`,
    getProductGroupByKey: `${baseUrl}/Common/GetProductGroupByKey`,
    getProductByGroup: `${baseUrl}/Common/GetProductByGroup`,
    addProduct: `${baseUrl}/Common/AddProduct`,
    addProductGroup: `${baseUrl}/Common/AddProductGroup`,
    getUserProductGroupList: `${baseUrl}/Common/GetUserProductGroupList`,
    getUserProductGroupListById: `${baseUrl}/Common/GetUserProductGroupListById`,
    deleteUserProductGroup: `${baseUrl}/Common/DeleteUserProductGroup`,
    addUserProductGroup: `${baseUrl}/Common/AddUserProductGroup`,
    getProductByKey: `${baseUrl}/Common/GetProductByKey`,
    bidRequestGroup: `${baseUrl}/Common/BidRequestGroup`,
    exchangeRate: `${baseUrl}/Common/GetExchangeRates`,
    getBrandByKey: `${baseUrl}/Common/GetBrandByKey`,
    getSectorByKey: `${baseUrl}/Common/GetSectorByKey`,
    addCompanySector: `${baseUrl}/Common/AddCompanySector`,
    getSector: `${baseUrl}/Common/GetSector`,
    addSector: `${baseUrl}/Common/AddSector`,
    faqs: `${baseUrl}/Common/Faqs`,
    contactUs: `${baseUrl}/Common/contactUs`,
  },
  bid: {
    addBid: `${baseUrl}/Bid/AddBid`,
    addBidV2: `${baseUrl}/Bid/AddBidV2`,
    addBidFile: `${baseUrl}/Bid/AddBidFile`,
    getMyBidList: `${baseUrl}/Bid/GetMyBidList`,
    getBidList: `${baseUrl}/Bid/GetBidList`,
    getBidRequestDetail: `${baseUrl}/Bid/GetBidRequestDetail`,
    addBidResponse: `${baseUrl}/Bid/AddBidResponse`,
    getBidResponseList: `${baseUrl}/Bid/GetBidResponseList`,
    addBidMatch: `${baseUrl}/Bid/AddBidMatch`,
    addBidMatchRateComment: `${baseUrl}/Bid/AddBidMatchRateComment`,
    discardBid: `${baseUrl}/Bid/DiscardBid`,
    closeBid: `${baseUrl}/Bid/CloseBid`,
    getMyBidResponseList: `${baseUrl}/Bid/GetMyBidResponseList`,
    addFavSeller: `${baseUrl}/User/AddFavSeller`,
    removeFavSeller: `${baseUrl}/User/RemoveFavSeller`,
    cancelBidResponse: `${baseUrl}/Bid/CancelBidResponse`,
    removeBidRequestFile: `${baseUrl}/Bid/RemoveBidRequestFile`,
    addWatchList: `${baseUrl}/Bid/AddWatchListBid`,
    removeWatchList: `${baseUrl}/Bid/RemoveWatchListBid`,
    addSpamReport: `${baseUrl}/Bid/AddSpamReport`,
    getMyBidListTabCounts: `${baseUrl}/Bid/GetMyBidListTabCounts`,
    getMyBidResponseListTabCounts: `${baseUrl}/Bid/GetMyBidResponseListTabCounts`,
    updateOrderStatus: `${baseUrl}/Bid/UpdateOrderStatus`,
    updateNote: `${baseUrl}/Bid/updateNote`,
    addPreBid: `${baseUrl}/Bid/AddPreBid`,
    addDraft: `${baseUrl}/Bid/AddDraft`,
    getMyPreBidList: `${baseUrl}/Bid/GetMyPreBidList`,
    getMyDraftList: `${baseUrl}/Bid/GetMyDraftList`,
    convertDraftToBidRequest: `${baseUrl}/Bid/ConvertDraftToBidRequest`,
    deleteDraft: `${baseUrl}/Bid/DeleteDraft`,
    getPreBidCreatedUserList: `${baseUrl}/Bid/GetPreBidCreatedUserList`,
    cancelDraft: `${baseUrl}/Bid/CancelDraft`,
  },
  chat: {
    getChatThreads: `${baseUrl}/Chat/GetChatThreads`,
    getChatMessages: `${baseUrl}/Chat/GetChatMessages`,
    sendMessage: `${baseUrl}/Chat/SendMessage`,
    getUnReadedMessageCount: `${baseUrl}/Chat/GetUnReadedMessageCount`,
    setReadedThread: `${baseUrl}/Chat/SetReadedThread`,
    setUnreadAllThread: `${baseUrl}/Chat/SetUnreadAllThread`,
  },
  notification: {
    getAllNotification: `${baseUrl}/Notification/GetAllNotification`,
    readAllNotification: `${baseUrl}/Notification/ReadAllNotification`,
    getNotifications: `${baseUrl}/Notification/GetNotifications`,
    getUnReadNotificationCount: `${baseUrl}/Notification/GetUnReadNotificationCount`,
    readNotification: `${baseUrl}/Notification/ReadNotification`,
  }
};

export { baseUrl };

export default urlConfig;
